import axios from 'axios';

// PROD
const PROD_URL = 'https://api.uat.blazpay.com';
const DEV_URL = 'https://api.uat.blazpay.com';
export const baseURL = 'https://api.uat.blazpay.com';

// // DEV
// const PROD_URL = 'http://localhost:5000';
// const DEV_URL = 'http://localhost:5000';
// export const baseURL = 'http://localhost:5000';

axios.defaults.baseURL = PROD_URL;
// eslint-disable-next-line no-undef
process.env.NODE_ENV === 'development' ? DEV_URL : PROD_URL;

axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.setToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

axios.interceptors.response.use(
  (response) => response.data?.data || response.data
);

export default axios;
